export const getHostname = (): string => window.location.hostname;

export const getHref = (): string => window.location.href;

export const assignHref = (href: string): void => {
  window.location.assign(href);
};
